import { matchPath } from 'react-router';

import { catchAll } from '@sorare/routing';

import { Sport } from '#src/__generated__/globalTypes.ts';
import { FOOTBALL, MLB, NBA } from '#src/constants/__generated__/routes.ts';
import { localStorage } from '#src/lib/storage/localStorage.ts';

export const sportFromCountry = (
  defaultSport?: Sport | null,
  defaultSportOnlyIfUS?: boolean
) => {
  const { sorareCountry = 'FR' } = document.documentElement.dataset;
  if (defaultSportOnlyIfUS) {
    return sorareCountry.toLowerCase() === 'us'
      ? defaultSport || Sport.NBA
      : Sport.FOOTBALL;
  }
  return (
    defaultSport ||
    (sorareCountry.toLowerCase() === 'us' ? Sport.NBA : Sport.FOOTBALL)
  );
};

const sportFromLocalStorage = (): Sport | undefined => {
  try {
    const storedSport = localStorage.getItem('sport') ?? '';

    switch (storedSport) {
      case 'FOOTBALL':
        return Sport.FOOTBALL;
      case 'BASEBALL':
        return Sport.BASEBALL;
      case 'NBA':
        return Sport.NBA;
      default:
        return undefined;
    }
  } catch {
    return undefined;
  }
};

export const sportFromPath = (path: string) => {
  const mainSport = sportFromLocalStorage() || sportFromCountry();

  if (matchPath(catchAll(NBA), path)) {
    return Sport.NBA;
  }
  if (matchPath(catchAll(MLB), path)) {
    return Sport.BASEBALL;
  }
  if (matchPath(catchAll(FOOTBALL), path)) {
    return Sport.FOOTBALL;
  }
  return mainSport;
};
